import BaseMaterial from './BaseMaterial';


export default (Vue) => {
  Vue.component(BaseMaterial.name, BaseMaterial);
};



// WEBPACK FOOTER //
// ./src/components/common/base-material/index.js